// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.nadLnalick3O4fGckVxZ{width:100%;min-width:220px;max-width:772px}.x63it6dDJdsInzjeUKeq{color:var(--content-primary-primary);grid-template-columns:auto 1fr;align-items:center;gap:8px;width:100%;margin-right:5px;font-size:13px;display:grid}.dedZNaH08RCYkIqN2hnk{text-overflow:ellipsis;white-space:nowrap;overflow:hidden}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"wrapper": `nadLnalick3O4fGckVxZ`,
	"selectLine": `x63it6dDJdsInzjeUKeq`,
	"selectValue": `dedZNaH08RCYkIqN2hnk`
};
export default ___CSS_LOADER_EXPORT___;
